(function (root, factory) {
  const core = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = core;
  }

  if (root) {
    root.MarineMaxAIChatCore = core;
  }
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  const constants = Object.freeze({
    MARINEMAX_GA4_MEASUREMENT_ID: 'G-94DH7ZWERF',
    AI_CHAT_GA4_GET_TIMEOUT_MS: 300,
    TYPING_DELAY: 60,
    RETRY_DELAY: 500,
    AI_CHAT_MAX_NETWORK_RETRIES: 2,
    AI_CHAT_REQUEST_TIMEOUT_MS: 15000,
  });

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function getChatErrorMessage(error) {
    const message = error && error.message ? String(error.message) : '';
    if (message.toLowerCase().includes('missinggreenlet')) {
      return 'AI service is temporarily unavailable. Please try again in a moment.';
    }
    return 'Error, try again';
  }

  function getPhoneMaskConfig(countryCode) {
    switch (countryCode) {
      case 'GB':
        return {
          prefix: '+44',
          placeholder: '+44 1234 567890',
          maxDigits: 10,
          formatter(digits) {
            const part1 = digits.slice(0, 4);
            const part2 = digits.slice(4, 10);
            let value = '+44';
            if (part1) value += ` ${part1}`;
            if (part2) value += ` ${part2}`;
            return value;
          },
        };
      case 'CA':
      case 'US':
      default:
        return {
          prefix: '+1',
          placeholder: '+1 (555) 000-0000',
          maxDigits: 10,
          formatter(digits) {
            const area = digits.slice(0, 3);
            const first = digits.slice(3, 6);
            const second = digits.slice(6, 10);
            let value = '+1';
            if (area.length) {
              value += ` (${area}`;
              if (area.length === 3) value += ')';
            }
            if (first.length) value += ` ${first}`;
            if (second.length) value += `-${second}`;
            return value;
          },
        };
    }
  }

  function getPhoneDigits(rawValue, config) {
    const raw = String(rawValue || '').trim();
    let digits = raw.replace(/\D/g, '');
    const prefixDigits = String(config.prefix || '').replace(/\D/g, '');
    const rawHasExplicitPrefix =
      !!prefixDigits &&
      (raw.startsWith(String(config.prefix || '')) ||
        raw.startsWith(`+${prefixDigits}`) ||
        raw.startsWith(prefixDigits));

    if (prefixDigits && rawHasExplicitPrefix && digits.startsWith(prefixDigits)) {
      digits = digits.slice(prefixDigits.length);
    }

    return digits.slice(0, config.maxDigits);
  }

  function getPhoneDigitsBeforeIndex(rawValue, index, config) {
    const raw = String(rawValue || '');
    const rawBefore = raw.slice(0, Math.max(0, index));
    const prefixDigits = String(config.prefix || '').replace(/\D/g, '');
    const hasExplicitPrefix =
      !!prefixDigits &&
      (raw.startsWith(String(config.prefix || '')) ||
        raw.startsWith(`+${prefixDigits}`) ||
        raw.startsWith(prefixDigits));
    let count = rawBefore.replace(/\D/g, '').length;

    if (hasExplicitPrefix) {
      count = Math.max(0, count - prefixDigits.length);
    }

    return count;
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
  }

  function isValidVerificationCode(value) {
    return /^\d{6}$/.test(String(value || '').trim());
  }

  function normalizeResponseMarkdown(markdown) {
    const response = String(markdown == null ? '' : markdown);

    return response
      .replace(/^\s{0,3}#{1,6}[ \t]+[^\r\n]*(?:\r?\n+|$)/, '')
      .replace(/^\s*([^\r\n]+)\r?\n(?:={3,}|-{3,})[ \t]*(?:\r?\n+|$)/, '')
      .replace(/^\s*(?:\*\*|__)[^\r\n]+(?:\*\*|__)[ \t]*(?:\r?\n+|$)/, '')
      .replace(/(^|\r?\n)[ \t]*•[ \t]+/g, '$1- ');
  }

  function splitBuyerName(fullName) {
    const cleaned = String(fullName || '').replace(/\s+/g, ' ').trim();
    if (!cleaned) return { first: '', last: '' };
    const parts = cleaned.split(' ');
    if (parts.length === 1) return { first: parts[0], last: '' };
    return { first: parts[0], last: parts.slice(1).join(' ') };
  }

  function formatCurrency(amount) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  }

  function formatDate(dateString) {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  }

  return Object.freeze({
    constants,
    escapeHtml,
    formatCurrency,
    formatDate,
    getChatErrorMessage,
    getPhoneDigits,
    getPhoneDigitsBeforeIndex,
    getPhoneMaskConfig,
    isValidEmail,
    isValidVerificationCode,
    normalizeResponseMarkdown,
    splitBuyerName,
  });
});
